import { Modal } from "react-bootstrap";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { getEDTByClassePDF } from "../../api/edt";
import { toast } from "sonner";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const EDTApercuByClass = ({ show, metaData, onClose }: Props) => {
  const [selectedClass, setSelectedClass] = useState<any>(metaData?.classes[0]);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchEDTByClassePDF = async () => {
    try {
      setIsLoading(true);
      setPdfBlobUrl("");
      const payload = {
        id_class: selectedClass?.id,
        id_versionEDT: metaData?.id_versionEDT,
      };
      const response = await getEDTByClassePDF(payload);
      // console.log("response: ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
    } catch (error: any) {
      // console.log("erreur génération aperçu emploi du temps: ", error);

      let errorMessage = "Une erreur s'est produite, réessayez plus tard";

      // Vérifie si on a bien un blob en réponse
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text(); // Convertir blob → texte
          const json = JSON.parse(text); // Parser texte → JSON
          errorMessage = json.error || json.message || errorMessage;
        } catch (parseErr) {
          // console.error("Impossible de parser l'erreur blob :", parseErr);
        }
      } else {
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          errorMessage;
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) setPdfBlobUrl("");
    if (show && !selectedClass) setSelectedClass(metaData?.selectedClass);
  }, [show]);

  useEffect(() => {
    if (show && selectedClass && metaData?.id_versionEDT) fetchEDTByClassePDF();
  }, [selectedClass]);

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onClose();
          setSelectedClass(undefined);
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Apercu de l'emploi du temps</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="d-flex align-items-center justify-content-between w-100 gap-3 ">
            <p className="fw-bold">
              {selectedClass?.name || "Aucune classe séléectionnée"}
            </p>
            <div>
              <button
                className="btn btn-outline-primary btn-sm me-2"
                onClick={() => {
                  const classes = metaData?.classes || [];
                  const currentIndex = classes.findIndex(
                    (c: any) => c.id === selectedClass?.id,
                  );
                  if (currentIndex > 0)
                    setSelectedClass(classes[currentIndex - 1]);
                }}
                disabled={
                  !metaData?.classes?.length ||
                  metaData.classes.findIndex(
                    (c: any) => c.id === selectedClass?.id,
                  ) <= 0
                }
              >
                <i className="fas fa-arrow-left"></i>
              </button>
              <button
                className="btn btn-outline-primary btn-sm "
                onClick={() => {
                  const classes = metaData?.classes || [];
                  const currentIndex = classes.findIndex(
                    (c: any) => c.id === selectedClass?.id,
                  );
                  if (currentIndex < classes.length - 1)
                    setSelectedClass(classes[currentIndex + 1]);
                }}
                disabled={
                  !metaData?.classes?.length ||
                  metaData.classes.findIndex(
                    (c: any) => c.id === selectedClass?.id,
                  ) >=
                    metaData.classes.length - 1
                }
              >
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!pdfBlobUrl && isLoading ? (
              <Spin
                indicator={
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              />
            ) : (
              <iframe
                src={pdfBlobUrl}
                style={{ width: "100%", height: "100%" }}
                title="Aperçu PDF"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  EDTApercuByClass,
  [buildPermission(Resource.EDT, Action.READ)],
  "masquer",
);
